import React from 'react';
import { useEnvironment } from '../utils/EnvironmentContext';
import './EnvironmentSelector.css';

const EnvironmentSelector = () => {
  const { env, setEnv } = useEnvironment();

  const handleChange = (e) => {
    setEnv(e.target.value);
  };

  return (
    <select className="env-select" value={env} onChange={handleChange}>
      <option value="memo">Memo</option>
      <option value="offitel">Offitel</option>
    </select>
  );
};

export default EnvironmentSelector;
